/*
* Some functions used by both FilterOptions.vue and ThemeDetails.vue
  for showing filter operator options
*/

import { DOMAIN_TYPE, VALUE_INPUT_TYPE } from '../../constants';
import { removeXmlPrefix, getRefcodesByName, convertToValueTextPair } from '../utilities';

export function filterOperatorOptions(filter) {
    if (!filter) {
        return null;
    }
    const classifiedDataType = classifyDataType(filter.dataType);
    const possibleOperators = getListPossibleOperators(
        classifiedDataType,
        isInputDomainAndTypeAllValues(filter)
    );

    // Reset operator if value is not in list of possible operators
    if (
        filter.operator &&
        !possibleOperators.some((o) => o.code === filter.operator)
    ) {
        filter.operator = null;
    }
    return convertToValueTextPair(
        possibleOperators,
        'code',
        'description'
    );
}
/**
 * Depending on the dataType and 'All values' at domain, a list of operators is provided
 * @param  {string} classifiedDataType for which the list of operators is composed
 * @param  {bool} InputDomainAndTypeAllValues Option 'All values' is chosen at domain true or false
 * @return {array} list of operators
 */
export function getListPossibleOperators(
    classifiedDataType,
    InputDomainAndTypeAllValues
) {
    const allOperators = getRefcodesByName('OPERATOR');
    if (InputDomainAndTypeAllValues) {
        return allOperators.filter((o) => ['=', 'C'].includes(o.code));
    }

    switch (classifiedDataType) {
        case 'string':
            return allOperators.filter((o) =>
                [
                    '<=',
                    '<>',
                    '=',
                    '>=',
                    'C',
                    '>',
                    '<',
                    'S',
                    'E'
                ].includes(o.code)
            );
        case 'boolean':
            return allOperators.filter((o) =>
                ['=', '<>'].includes(o.code)
            );
        case 'integer':
        case 'float':
        case 'datetime':
            return allOperators.filter((o) =>
                ['=', '<>', '>', '>=', '<', '<='].includes(o.code)
            );
        default:
            return [];
    }
}

/**
 * Classifies the datatypes to either 1) string, 2) boolean, 3) integer, 4) float, 5) datetime or 6) unknown
 * @param  {string} dataType the real dataType as retrieved from the OGC Web Service
 * @return {string} the classified dataType, as used in NedGlobe Dashboard
 */
export function classifyDataType(dataType) {
    const filteredDataType = removeXmlPrefix(dataType);

    const integerTypes = ['int', 'negativeInteger', 'long', 'short', 'byte', 'integer'];
    const floatTypes = ['float', 'double', 'decimal', 'number'];
    const datetimeTypes = ['date', 'dateTime', 'time', 'timestamp'];

    if (integerTypes.includes(filteredDataType)) {
        return 'integer';
    } else if (floatTypes.includes(filteredDataType)) {
        return 'float';
    } else if (datetimeTypes.includes(filteredDataType)) {
        return 'datetime';
    } else if (filteredDataType === 'string') {
        return 'string';
    } else if (filteredDataType === 'boolean') {
        return 'boolean';
    } else {
        return 'unknown';
    }
}

export function isInputDomainAndTypeAllValues(filter) {
    return (
        filter.domainType === DOMAIN_TYPE.ALL_VALUES && filter.valueInput === VALUE_INPUT_TYPE.DOMAIN
    );
}
